// extracted by mini-css-extract-plugin
export var animationContainer = "_ep-0";
export var asteriskIcon = "_ep-8";
export var conversationLeftSection = "_ep-4";
export var conversationListItem = "_ep-3";
export var conversationMiddleSection = "_ep-5";
export var conversationRightSection = "_ep-6";
export var detailsContent = "_ep-1";
export var listContainer = "_ep-7";
export var modalContent = "_ep-2";